import { DOAbnormalTableHeaderData } from './interface/do-abnormal-table-header-data';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { LaasOption } from './../../../../core/models/laas-option';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ChangeDetectorRef, Component, Injector, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { PageInfo } from 'src/app/core/models/page-info';
import { deepCopy, getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Checkbox } from 'primeng/checkbox';
import { throwError, Subscription, fromEvent, debounceTime, distinctUntilChanged } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { Chips } from 'primeng/chips';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { UserService as UserDataService } from '../../../user/services/user-service.service';
import { Dialog } from 'primeng/dialog';
import { DOAbnormalTableHeaderGetRequest } from './interface/do-abnormal-table-header-get-request';
import { DoAbnormalService } from '../../services/do-abnormal.service';
import { DOAbnormalTableHeaderUpdateBean } from './interface/do-abnormal-table-header-update-bean';
import { DOAbnormalTableDetailData } from './interface/do-abnormal-table-detail-data';
import { DOAbnormalTableDetailGetRequest } from './interface/do-abnormal-table-detail-get-request';
import { DOAbnormalTableAbnormalItemGetRequest } from './interface/do-abnormal-table-abnormal-item-get-request';
import { DOAbnormalTableAbnormalItemData } from './interface/do-abnormal-table-abnormal-item-data';
import { DOAbnormalTableAbnormalItemSaveRequest } from './interface/do-abnormal-table-abnormal-item-save-request';
import { DOAbnormalMailRequest } from './interface/do-abnormal-mail-request';
import { DOAbnormalCreateAbnormalItemRequest } from './interface/do-abnormal-create-abnormal-item-request';
import { DOAbnormalDialogAbnormalItemFileUpdateRequest } from './interface/do-abnormal-dialog-abnormal-item-file-update-request';
import { DOAbnormalDialogItemFile } from './interface/do-abnormal-dialog-abnormal-item-file';
import { DOAbnormalItemFileBase64Bean } from './interface/do-abnormal-item-file-base64-bean';
import { DomSanitizer } from '@angular/platform-browser';
import { DOAbnormalTableHeaderUpdateRequest } from './interface/do-abnormal-table-header-update-request';
import { DOAbnormalItemFileResponse } from './interface/do-abnormal-item-file-response';
import { ActivatedRoute, Params } from '@angular/router';
import { UserPreferenceConstants } from '../../../../core/constants/user-preference-constants.constant';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { DOAbnormalItemFilesRequest } from './interface/do-abnormal-item-file-request';
import { startOfDay, endOfDay } from 'date-fns';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';
import { Subject } from 'rxjs';


export enum DisplayMode {
  Desktop,
  Mobile
}

export enum AbnormalItemFileDialogMode {
  Edit,
  Download
}
@Component({
  selector: 'laas-do-abnormal',
  templateUrl: './do-abnormal.component.html',
  styleUrls: ['./do-abnormal.component.scss']
})
export class DoAbnormalComponent extends SessionBaseComponent implements OnInit {

  readonly ERROR_CODE_CATEGORY = "DOAbnormal"

  //#region Permission Variable
  readonly viewPermissionCode = PermissionConstants.ViewDOAbnormal;
  readonly DOAbnormalSendNotification = PermissionConstants.DOAbnormalSendNotification;
  readonly DOAbnormalReplyNotification = PermissionConstants.DOAbnormalReplyNotification;
  readonly DOAbnormalEdit = PermissionConstants.DOAbnormalEdit
  readonly DOAbnormalUpload = PermissionConstants.DOAbnormalUpload

  currentLang: string = this.laasSetting.language;
  //#endregion Permission Variable

  //#region RWD Variable

  displayMode: DisplayMode = DisplayMode.Desktop; // desktop or mobile
  readonly MOBILE_MODE_WINDOW_WIDTH = 640; // the breakpoint of responsive table of current version is 640px
  readonly DISPLAY_MODE_ENUM = DisplayMode;
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;
  mobileTabPanelActiveIndex: number = 0;

  //#endregion RWD Variable

  //#region Option Variable


  orderQueryScope: OrderQueryScopeEnum = this.OrderQueryScopeEnum.personal;
  facilityOptions: FacilityOptions[] = [];
  customerOptions: LaasOption[] = [];
  waitingReferenceOptions: LaasOption[] = [];
  emailMarkOptions: LaasOption[] = [
    { label: 'Y', value: 1 },
    { label: 'N', value: 0 }
  ]
  consigneeKeyOptions: LaasOption[] = [];

  searchParams: any;
  //#endregion Option Variable

  //#region Search Form Variable

  isSearchFormOpen: boolean = true;
  searchFormGroup: FormGroup;
  etdMinDate: Date = new Date();
  etdMaxDate: Date = endOfDay(new Date());
  queryFlag: boolean = true;



  //#endregion Search Form Variable

  //#region Header Table Variable

  readonly headerPreferenceKey: string = UserPreferenceConstants.DOAbnormalTableHeaderData;
  // The Header table for Header table part
  @ViewChild('headerTable') headerTable!: Table;
  // Checkbox in the Header table's header
  @ViewChild('headerCheckboxOfHeaderTable') headerCheckboxOfHeaderTable!: Checkbox
  // Checkboxes in the Header table's row
  @ViewChildren('rowCheckboxOfHeaderTable') rowCheckboxesOfHeaderTable!: QueryList<Checkbox>

  @ViewChild('etdDt') etdDt!: CalendarComponent;

  // Status for show Header Table
  isHeaderTableOpen: boolean = false;
  // Status for the loading circle on the Header table
  isHeaderTableLoading: boolean = false;
  // Status for enabling a user to edit the data on the Header table
  isHeaderTableInEditMode: boolean = false;
  // All the columns of the Header table have
  columnGroupOfheaderTable: DateTableColumn[] = [
    { field: 'specLocType', header: 'DOAbnormal.Table.Header.ColumnHeader.SpecLocType', sort: true, filter: { type: 'text' } },
    { field: 'customer', header: 'DOAbnormal.Table.Header.ColumnHeader.Customer', sort: true, filter: { type: 'text' } },
    { field: 'doNo', header: 'DOAbnormal.Table.Header.ColumnHeader.DoNo', sort: true, filter: { type: 'text' } },
    { field: 'moNo', header: 'DOAbnormal.Table.Header.ColumnHeader.MoNo', sort: true, filter: { type: 'text' } },
    { field: 'eta', header: 'DOAbnormal.Table.Header.ColumnHeader.ETA', sort: true, filter: { type: 'date' } },
    { field: 'etd', header: 'DOAbnormal.Table.Header.ColumnHeader.ETD', sort: true, filter: { type: 'date' } },
    { field: 'waitingReference', header: 'DOAbnormal.Table.Header.ColumnHeader.WaitingReference', sort: true, filter: { type: 'text' } },
    { field: 'notifyUser', header: 'DOAbnormal.Table.Header.ColumnHeader.NotifyUser', sort: true, filter: { type: 'text' } },
    { field: 'notifyDt', header: 'DOAbnormal.Table.Header.ColumnHeader.NotifyDt', sort: true, filter: { type: 'date' } },
    { field: 'notifyFlag', header: 'DOAbnormal.Table.Header.ColumnHeader.NotifyFlag', sort: true, filter: { type: 'multiselect', multiselectOptions: this.emailMarkOptions } },
    { field: 'replyUser', header: 'DOAbnormal.Table.Header.ColumnHeader.ReplyUser', sort: true, filter: { type: 'text' } },
    { field: 'replyDt', header: 'DOAbnormal.Table.Header.ColumnHeader.ReplyDt', sort: true, filter: { type: 'date' } },
    { field: 'replyFlag', header: 'DOAbnormal.Table.Header.ColumnHeader.ReplyFlag', sort: true, filter: { type: 'multiselect', multiselectOptions: this.emailMarkOptions } }
  ];
  // The columns user choose to display on the Header table
  selectedColumnGroupOfHeaderTable: DateTableColumn[] = [];
  // Current data on the Header table
  dataOfheaderTable: DOAbnormalTableHeaderData[] = [];
  // Backup Header data when Header data retrieved from the back-end
  backupDataOfHeaderTable: DOAbnormalTableHeaderData[] = [];
  // User current selected row on the Header table
  selectedRowOfHeaderTable: DOAbnormalTableHeaderData | null = null;
  // User last selected row on the Header table
  previousSelectedRowOfHeaderTable: DOAbnormalTableHeaderData | null = null;
  // Checked Header Table Row
  checkedRowOfHeaderTable: DOAbnormalTableHeaderData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfHeaderTable: any = [5, 10, 20];

  // Records for user's operation on the Header table
  updatedHeaderList: DOAbnormalTableHeaderUpdateBean[] = [];

  // Header table paging info
  pageInfoOfHeaderTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Header table sorting info
  sortInfoOfHeaderTable: SortOrder = {
    property: "DoNo,MoNo",
    direction: -1
  }

  //#endregion Header Table Variable

  //#region Detail Table Variable

  readonly detailPreferenceKey: string = UserPreferenceConstants.DOAbnormalTableDetailData;
  // Status for show New Abnormal Item Dialog
  isShowNewAbnormalItemDialog: boolean = false;
  // Status for the loading circle on the Detail table
  isDetailTableLoading: boolean = false;
  // Status for show Detail Table
  isDetailTableOpen: boolean = false;
  // The Detail table for Detail table part
  @ViewChild('detailTable') detailTable!: Table;
  // Checkbox in the Detail table's header
  @ViewChild('headerCheckboxOfDetailTable') headerCheckboxOfDetailTable!: Checkbox
  // Checkboxes in the Detail table's row
  @ViewChildren('rowCheckboxOfDetailTable') rowCheckboxesOfDetailTable!: QueryList<Checkbox>
  // All the columns of the Detail table have
  columnGroupOfDetailTable: DateTableColumn[] = [
    { field: 'sku', header: 'DOAbnormal.Table.Detail.ColumnHeader.SKU', sort: true, filter: { type: 'text' } },
    { field: 'externLineNo', header: 'DOAbnormal.Table.Detail.ColumnHeader.ExternLineNo', sort: true, filter: { type: 'text' } },
    { field: 'originalQty', header: 'DOAbnormal.Table.Detail.ColumnHeader.OriginalQty', sort: true, filter: { type: 'numeric' } },
    { field: 'seqNo', header: 'DOAbnormal.Table.Detail.ColumnHeader.SeqNo', sort: true, filter: { type: 'numeric' } },
  ];
  // The columns user choose to display on the Detail table
  selectedColumnGroupOfDetailTable: DateTableColumn[] = [];
  // Current data on the Detail table
  dataOfDetailTable: DOAbnormalTableDetailData[] = [];
  // User current selected row on the Header table
  selectedRowOfDetailTable: DOAbnormalTableDetailData | null = null;
  // Checked Detail Table Row
  checkedRowOfDetailTable: DOAbnormalTableDetailData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfDetailTable: any = [5, 10, 20];

  // Detail table paging info
  pageInfoOfDetailTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Detail table sorting info
  sortInfoOfDetailTable: SortOrder = {
    property: "SeqNo",
    direction: -1
  }

  //#endregion Detail Table Variable

  //#region Abnormal Item Table Variable

  readonly abnormalItemPreferenceKey: string = UserPreferenceConstants.DOAbnormalTableAbnormalItemData;
  // The Abnormal Item table for Abnormal Item table part
  @ViewChild('abnormalItemTable') abnormalItemTable!: Table;
  // Checkbox in the Abnormal Item table's header
  @ViewChild('headerCheckboxOfAbnormalItemTable') headerCheckboxOfAbnormalItemTable!: Checkbox
  // Checkboxes in the Abnormal Item table's row
  @ViewChildren('rowCheckboxOfAbnormalItemTable') rowCheckboxesOfAbnormalItemTable!: QueryList<Checkbox>
  // Status for show Abnormal Item Table
  isAbnormalItemTableOpen: boolean = false;
  // Status for the loading circle on the Abnormal Item table
  isAbnormalItemTableLoading: boolean = false;
  // Status for enabling a user to edit the data on the Abnormal Item table
  isAbnormalItemTableInEditMode: boolean = false;
  // All the columns of the Abnormal Item table have
  columnGroupOfAbnormalItemTable: DateTableColumn[] = [
    { field: 'waitingReference', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.WaitingReference', sort: true },
    { field: 'waitingReferenceDesc', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.WaitingReferenceDesc', sort: true },
    { field: 'abnormalQty', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.AbnormalQty', sort: true },
    { field: 'file', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.File', sort: false },
    { field: 'relatedDetailSeqNos', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.RelatedDetailSeqNo', sort: false },
    { field: 'handleMethod', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.HandleMethod', sort: true, filter: { type: 'text' } },
    { field: 'notes', header: 'DOAbnormal.Table.AbnormalItem.ColumnHeader.Notes', sort: true },
  ]
  // The columns user choose to display on the Abnormal Item table
  selectedColumnGroupOfAbnormalItemTable: DateTableColumn[] = []
  // Current data on the Abnormal Item table table
  dataOfAbnormalItemTable: DOAbnormalTableAbnormalItemData[] = [];
  // Backup Abnormal Item data when Abnormal Item data retrieved from the back-end
  backupDataOfAbnormalItemTable: DOAbnormalTableAbnormalItemData[] = [];
  // User current selected row on the Abnormal Item table
  selectedRowOfAbnormalItemTable: DOAbnormalTableAbnormalItemData | null = null;
  // User last selected row on the Abnormal Item table
  previousSelectedRowOfAbnormalItemTable: DOAbnormalTableAbnormalItemData | null = null;
  // Checked Abnormal Item Table Row
  checkedRowOfAbnormalItemTable: DOAbnormalTableAbnormalItemData[] = [];
  // Because p-table rowsPerPageOptions any[] cannot set to null on html
  // so use any type variable and set it to p-table rowsPerPageOptions
  rowsPerPageOptionsOfAbnormalItemTable: any = [5, 10, 20];
  // Subscription for getting file
  getFileSubscribe: Subscription | null = null;

  // Records for user's operation on the table
  newAbnormalItemList: DOAbnormalTableAbnormalItemData[] = [];
  updatedAbnormalItemList: DOAbnormalTableAbnormalItemData[] = [];
  deletedSeqNoGroupOfAbnormalItemTable: number[] = [];

  // For data key to distinguish the added rows on the Abnormal Item table
  newAbnormalItemDataKeyId: number = 0;
  // Abnormal Item table paging info
  pageInfoOfAbnormalItemTable: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };

  // Abnormal Item table sorting info
  sortInfoOfAbnormalItemTable: SortOrder = {
    property: "SeqNo",
    direction: -1
  }

  //check login usertype is not tenant
  isTenant: boolean = false;

  //#endregion Abnormal Item Table Variable

  //#region New Abnormal Item Dialog Variable

  isNewAbnormalItemDialogLoading: boolean = false;
  newAbnormalItemDialogFormGroup: FormGroup;

  //#region File Table Variable

  // The File table for File table part
  @ViewChild('fileTable') fileTable!: Table;
  // All the columns of the File table have
  columnGroupOfFileTable: DateTableColumn[] = [
    { field: 'fileName', header: 'DOAbnormal.Dialog.NewAbnormalItem.Table.File.ColumnHeader.FileName', sort: true },
  ]
  // Current data on the Detail table
  dataOfFileTable: File[] = [];

  //#endregion File Table Variable

  //#region Related Detail Table Variable

  @ViewChild('newAbnormalItemDialog') newAbnormalItemDialog!: Dialog;
  // Checkbox in the Related Detail table's header
  @ViewChild('headerCheckboxOfRelatedDetailTable') headerCheckboxOfRelatedDetailTable!: Checkbox
  // Checkboxes in the Related Detail table's row
  @ViewChildren('rowCheckboxOfRelatedDetailTable') rowCheckboxesOfRelatedDetailTable!: QueryList<Checkbox>
  // All the columns of the Related Detail table have
  columnGroupOfRelatedDetailTable: DateTableColumn[] = [
    { field: 'sku', header: 'DOAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.SKU', sort: true },
    { field: 'externLineNo', header: 'AdvisingAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.ExternLineNo', sort: true },
    { field: 'originalQty', header: 'DOAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.OriginalQty', sort: true },
    { field: 'seqNo', header: 'DOAbnormal.Dialog.NewAbnormalItem.Table.RelatedDetail.ColumnHeader.SeqNo', sort: true },
  ];
  // The columns user choose to display on the Related Detail table
  selectedColumnGroupOfRelatedDetailTable: DateTableColumn[] = [];
  // Current data on the Related Detail table
  dataOfRelatedDetailTable: DOAbnormalTableDetailData[] = [];
  // Checked Related Detail Table Row
  checkedRowOfRelatedDetailTable: DOAbnormalTableDetailData[] = [];

  //#endregion File Table Variable

  //#endregion New Abnormal Item Dialog Variable

  //#region Abnormal Item File Dialog Variable

  @ViewChild('abnormalItemFileDialog') abnormalItemFileDialog!: Dialog
  isShowAbnormalItemFileDialog: boolean = false;
  isAbnormalItemFileDialogLoading: boolean = false;
  isShowBigFile: boolean = false;
  readonly ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM = AbnormalItemFileDialogMode;
  abnormalItemFileDialogMode: AbnormalItemFileDialogMode = AbnormalItemFileDialogMode.Edit;

  // Abnormal Item File Dialog data
  fileDocIdOfCurrentAbnormalItem: string[] = [];
  fileOfAbnormalItemFileDialog: DOAbnormalDialogItemFile[] = [];
  backupFileOfAbnormalItemFileDialog: DOAbnormalDialogItemFile[] = [];

  // Index for Galleria
  indexOfGalleria: number = 0;

  // Records for user's operation on the this dialog
  newAbnormalItemFileBase64s: DOAbnormalItemFileBase64Bean[] = [];
  deletedAbnormalItemFileDocIds: string[] = [];

  //fileDeletePermission
  filePermission: boolean | null;

  //#endregion Abnormal Item File Dialog Variable

  //#region Constructor

  constructor(
    private injector: Injector,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder,
    private facilityService: FacilityService,
    private userDataService: UserDataService,
    private commonDataService: CommonDataService,
    private doAbnormalService: DoAbnormalService,
    private route: ActivatedRoute,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private changeDetector: ChangeDetectorRef,
    private dropdownOptionsService: DropdownOptionsService
  ) {
    super(injector)
    let windowResizeEventListener = this.onWindowResize.bind(this)
    window.addEventListener('resize', windowResizeEventListener)
    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    }

    this.searchFormGroup = this.formBuilder.group({
      orderQueryScope: [OrderQueryScopeEnum.personal, Validators.required],
      facilities: null,
      customers: [],
      doNos: null,
      invoiceNos: null,
      etd: null,
      notified: null,
      replied: null
    })
    this.initCalendarMinMaxDateRange();

    this.newAbnormalItemDialogFormGroup = this.formBuilder.group({
      abnormalQty: null,
      waitingReference: null,
      waitingReferenceDesc: null
    })

    this.initAllOption();
    this.initAllTable();

    this.searchParams = {
      consigneeKey: null,
      consigneeCompany: null
    }

    this.filePermission = true;

  }

  //#region Initial

  //#region Initial Calendar Min-Max Date Range

  private initCalendarMinMaxDateRange() {
    let today = new Date();
    let currentMonth = today.getMonth();
    let currentYear = today.getFullYear();
    let minDateMonth = (currentMonth === 0) ? 11 : currentMonth - 1;
    let minDateYear = (minDateMonth === 11) ? currentYear - 1 : currentYear;
    this.etdMinDate.setMonth(minDateMonth);
    this.etdMinDate.setFullYear(minDateYear);
    this.etdMinDate = startOfDay(this.etdMinDate);
  }

  //#endregion Initial Calendar Min-Max Date Range

  //#region Initial Option

  private initAllOption() {
    this.initFacilityOption();
    this.initCustomerOption();
    this.initWaitingReferenceOption();
  }

  private initFacilityOption() {
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options;
      }
    })
  }

  private initCustomerOption() {
    this.userDataService.getCustomerOptions().then(options => {
      for (let option of options) {
        this.customerOptions.push({
          label: `${option.customerCode} - ${option.customerName}`,
          value: option.customerCode
        })
      }
    })
  }

  private initWaitingReferenceOption() {
    this.dropdownOptionsService.getWaitingReferenceOption(true, this.laasSetting.facility).subscribe({
      next: (options) => {
        options.sort();
        for (let option of options) {
          this.waitingReferenceOptions.push({
            label: `${option.valueField} - ${option.textField}`,
            value: option.valueField
          })
        }
      }
    })
  }


  //#endregion Initial Option

  //#region Initial Table

  private initAllTable() {
    this.initHeaderTable();
    this.initDetailTable();
    this.initAbnormalItemTable();
    this.initRelatedDetailTable();
  }

  private initHeaderTable() {
    this.selectedColumnGroupOfHeaderTable = this.columnGroupOfheaderTable
  }

  private initDetailTable() {
    this.selectedColumnGroupOfDetailTable = this.columnGroupOfDetailTable
  }

  private initAbnormalItemTable() {
    this.selectedColumnGroupOfAbnormalItemTable = this.columnGroupOfAbnormalItemTable;
  }

  private initRelatedDetailTable() {
    this.selectedColumnGroupOfRelatedDetailTable = this.columnGroupOfRelatedDetailTable;
  }

  customerInput$ = new Subject<string>();

  //#endregion Initial Table

  //#endregion Initial

  //#endregion Constructor

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.initAllOption();

    // get param to auto query
    this.route.queryParams.subscribe((params: Params) => {
      params = Object.values(params);
      const replied = params.slice(1, 2);
      if (params.length != 0) {
        const doNo = params[0].split(";");
        this.searchFormGroup.value.doNos = doNo;
        this.searchFormGroup.controls["doNos"].setValue(doNo);

        let headerTableGetRequest: DOAbnormalTableHeaderGetRequest = this.createHeaderGetRequest();
        const did = 1;
        // 已通知，value = 1，因為收到信一定是已通知，所以預設notified一定為Y
        this.searchFormGroup.value.notified = headerTableGetRequest.notified = did;

        // 已回覆，value = 1，預設replied為空，CSR已回覆才會為Y
        if (replied.length != 0) {
          this.searchFormGroup.value.replied = headerTableGetRequest.replied = did;
        }
        this.searchBtnClick();

      }

      this.isTenant = this.userProfile.userType == "Tenant" ? false : true;

    });

    this.customerInput$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(conText => {
      this.getCustomerOptions({ filter: conText });
    });

  }

  //#region Table Column Filter
  set selectedColumnsOfHeaderTable(cols: DateTableColumn[]) {
    this.selectedColumnGroupOfHeaderTable = this.columnGroupOfheaderTable.filter(col => cols.includes(col));
  }

  set selectedColumnsOfDetailTable(cols: DateTableColumn[]) {
    this.selectedColumnGroupOfDetailTable = this.columnGroupOfDetailTable.filter(col => cols.includes(col));
  }

  set selectedColumnsOfAbnormalItemTable(cols: DateTableColumn[]) {
    this.selectedColumnGroupOfAbnormalItemTable = this.columnGroupOfAbnormalItemTable.filter(col => cols.includes(col))
  }

  @Input() get selectedColumnsOfRelatedDetailTable(): DateTableColumn[] {
    return this.selectedColumnGroupOfRelatedDetailTable;
  }

  set selectedColumnsOfRelatedDetailTable(cols: DateTableColumn[]) {
    this.selectedColumnGroupOfRelatedDetailTable = this.columnGroupOfRelatedDetailTable.filter(col => cols.includes(col))
  }

  //#endregion Table Column Filter

  //#region Common Function

  // Prevent children event trigger parent event
  stopBubblingPhases(event: Event) {
    event.stopPropagation()
  }

  //#endregion Common Function

  //#region Window resize Function

  onWindowResize() {
    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    }
    else {
      this.changeToDesktopMode();
    }
  }

  isInDesktopMode(): boolean {
    return this.displayMode === this.DISPLAY_MODE_ENUM.Desktop;
  }

  private changeToMobileMode() {
    this.displayMode = DisplayMode.Mobile
    this.rowsPerPageOptionsOfHeaderTable = null;
    this.rowsPerPageOptionsOfDetailTable = null;
    this.rowsPerPageOptionsOfAbnormalItemTable = null;
  }

  private changeToDesktopMode() {
    this.displayMode = DisplayMode.Desktop
    this.rowsPerPageOptionsOfHeaderTable = [5, 10, 20];
    this.rowsPerPageOptionsOfDetailTable = [5, 10, 20];
    this.rowsPerPageOptionsOfAbnormalItemTable = [5, 10, 20];
  }

  //#endregion Window resize Function

  //#region Search Form Function

  /**
   * Add Chips Item by comma ',' in mobile version
   */
  addItemByComma(event: Event, chips: Chips) {
    if ((event as InputEvent).data === ',') {
      let value = chips.inputViewChild.nativeElement.value.slice(0, -1);
      if (value !== '') {
        chips.addItem(event, value, true);
      }
    }
  }

  /**
   * Handle form Do No added event
   */
  doNoChipsAdded(event: { originalEvent: Event, value: string }): void {
    const eventValue: string = event.value;
    const parsedValues: string[] = eventValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchFormGroup.value.doNos.pop()
    for (let value of parsedValues) {
      this.searchFormGroup.value.doNos.push(value)
    }
  }

  /**
   * Handle form Invoice No added event
   */
  invoiceNoChipsAdded(event: { originalEvent: Event, value: string }): void {
    const eventValue: string = event.value;
    const parsedValues: string[] = eventValue.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchFormGroup.value.invoiceNos.pop()
    for (let value of parsedValues) {
      this.searchFormGroup.value.invoiceNos.push(value)
    }
  }

  /**
   * Fill Date into ETD field
   */
  fillETDField(event: Event, option: number) {
    let today = new Date();
    let currentMonth = today.getMonth();
    let currentYear = today.getFullYear();
    let startDate = new Date();

    switch (option) {
      case 2:
        startDate.setDate(today.getDate() - today.getDay());
        break;
      case 3:
        startDate.setDate(today.getDate() - 3);
        break;
      case 4:
        startDate.setDate(today.getDate() - 7);
        break;
      case 5:
        startDate.setDate(today.getDate() - 14);
        break;
      case 6:
        var startDateMonth = (currentMonth === 0) ? 11 : currentMonth - 1;
        var startDateYear = (startDateMonth === 11) ? currentYear - 1 : currentYear;
        startDate.setMonth(startDateMonth);
        startDate.setFullYear(startDateYear);
        break;
      default:
        break;
    }
    this.searchFormGroup.controls['etd'].setValue([startDate, today]);
    this.stopBubblingPhases(event);
  }

  /**
   * Check if user input one of those required fields
   */
  checkRequiredField = (): boolean => {
    if (this.searchFormGroup.value.notified == 1 && this.searchFormGroup.value.replied == 1) {
      if (
        !this.isRequiredFieldFilled(this.searchFormGroup.value.customers)
        && !this.isRequiredFieldFilled(this.searchFormGroup.value.doNos)
        && !this.isRequiredFieldFilled(this.searchFormGroup.value.invoiceNos)
        && !this.isETDFilled()
      ) {
        return true;
      }
    }
    return false;
  }

  /**
   * Check if common required field is filled
   */
  private isRequiredFieldFilled(values: string[]) {
    return !isNullOrEmpty(values) && values.length > 0;
  }

  /**
   * Check if ETD calendar field is filled
   */
  private isETDFilled(): boolean {
    return this.searchFormGroup.value.etd != null &&
      this.searchFormGroup.value.etd.length == 2 && this.searchFormGroup.value.etd[1] != null
  }

  searchBtnClick() {
    if (this.checkRequiredField()) {
      this.toastService.warn(this.translateService.instant('DOAbnormal.Form.Toast.NoInputAnyRequiredField'))
      return;
    }

    this.mobileTabPanelActiveIndex = 1;
    this.isSearchFormOpen = false;

    this.isHeaderTableOpen = true;
    this.isHeaderTableInEditMode = false;

    this.pageInfoOfHeaderTable.pageIndex = 0;
    this.headerTable.first = 0;
    this.getHeaderTableData();
  }

  private getHeaderTableData() {
    this.isHeaderTableLoading = true;
    this.restoreHeaderInternalData();

    let headerTableGetRequest: DOAbnormalTableHeaderGetRequest = this.createHeaderGetRequest();
    this.doAbnormalService.findDoAbnormalHeader(headerTableGetRequest).subscribe({
      next: (response) => {
        this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
        if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
          this.setHeaderDataByServiceResponse(response);
          if (this.selectedRowOfHeaderTable?.moNo) {
            this.isDetailTableOpen = true;
            this.pageInfoOfDetailTable.pageIndex = 0;
            this.detailTable.first = 0;
            this.getDetailTableData();

            this.isAbnormalItemTableOpen = true;
            this.isAbnormalItemTableInEditMode = false;
            this.pageInfoOfAbnormalItemTable.pageIndex = 0;
            this.abnormalItemTable.first = 0;
            this.getAbnormalItemTableData();
          }
          else {
            this.clearDetailTable();
            this.clearAbnormalItemTable();
          }
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.clearHeaderTable();
        this.toastService.error(this.translateService.instant('DOAbnormal.Table.Header.Toast.Failure.GetDataFail') + response.status);
      },
      complete: () => {
        this.isHeaderTableLoading = false;
        this.headerCheckboxOfHeaderTable.writeValue(false);
      }
    })
  }

  private createHeaderGetRequest(): DOAbnormalTableHeaderGetRequest {
    let headerTableGetRequest: DOAbnormalTableHeaderGetRequest = new DOAbnormalTableHeaderGetRequest();
    headerTableGetRequest.orderQueryScope = this.searchFormGroup.value.orderQueryScope;
    headerTableGetRequest.userEmail = this.userService.userInfo.email;
    headerTableGetRequest.facilities = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.facilities);
    headerTableGetRequest.consigneeKeys = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.customers);
    headerTableGetRequest.doNos = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.doNos);
    headerTableGetRequest.invoiceNos = this.convertEmptyStringArrayToNull(this.searchFormGroup.value.invoiceNos);
    if (this.searchFormGroup.value.etd) {
      headerTableGetRequest.startDate = this.searchFormGroup.value.etd[0];
      headerTableGetRequest.endDate = this.searchFormGroup.value.etd[1];
    }
    headerTableGetRequest.notified = this.searchFormGroup.value.notified;
    headerTableGetRequest.replied = this.searchFormGroup.value.replied;
    headerTableGetRequest.pageIndex = this.pageInfoOfHeaderTable.pageIndex;
    headerTableGetRequest.pageSize = this.pageInfoOfHeaderTable.pageSize;
    headerTableGetRequest.sortOrder = this.sortInfoOfHeaderTable;

    headerTableGetRequest.roleCodes = this.convertEmptyStringArrayToNull(this.userProfile.roles.map((role: { roleCode: any; }) => role.roleCode))
    headerTableGetRequest.userType = this.userProfile.userType

    headerTableGetRequest.userDataScopes = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewDOAbnormal);
    return headerTableGetRequest;
  }

  private convertEmptyStringArrayToNull(value: string[]): string[] | null {
    if (isNullOrEmpty(value) || value.length <= 0) {
      return null;
    }
    return value;
  }

  private setHeaderDataByServiceResponse(response: PageResp<DOAbnormalTableHeaderData>) {
    this.clearTableFilter(this.headerTable);
    // Update Table
    this.dataOfheaderTable = deepCopy(response.content) ?? [];
    this.backupDataOfHeaderTable = deepCopy(this.dataOfheaderTable) ?? [];
    this.selectedRowOfHeaderTable = this.dataOfheaderTable[0];
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.updateHeaderTableHighlight(this.selectedRowOfHeaderTable)

    if (this.isHeaderTableInEditMode) {
      this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
    }

    // Change page Info
    this.pageInfoOfHeaderTable.totalRecords = response.totalElements;
    this.pageInfoOfHeaderTable.totalPages = this.pageInfoOfHeaderTable.totalRecords / this.pageInfoOfHeaderTable.pageSize;
  }

  private clearHeaderTable() {
    this.clearTableFilter(this.headerTable);
    this.dataOfheaderTable = [];
    this.backupDataOfHeaderTable = [];
    this.selectedRowOfHeaderTable = null;
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.pageInfoOfHeaderTable.totalRecords = 0;
    this.pageInfoOfHeaderTable.totalPages = 0;
  }

  private getDetailTableData() {
    this.isDetailTableLoading = true;
    this.restoreDetailInternalData();

    let detailTableGetRequest: DOAbnormalTableDetailGetRequest = this.createDetailGetRequest();

    this.doAbnormalService.findDOAbnormalDetail(detailTableGetRequest).subscribe({
      next: (response) => {
        if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
          this.setDetailDataByServiceResponse(response);
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.clearDetailTable();
        this.toastService.error(this.translateService.instant('DOAbnormal.Table.Detail.Toast.Failure.GetDataFail') + response.status);
      },
      complete: () => {
        this.isDetailTableLoading = false;
      }
    })
  }

  private createDetailGetRequest(): DOAbnormalTableDetailGetRequest {
    let detailTableGetRequest: DOAbnormalTableDetailGetRequest = new DOAbnormalTableDetailGetRequest();
    detailTableGetRequest.moNo = this.selectedRowOfHeaderTable?.moNo ?? '';
    detailTableGetRequest.pageIndex = this.pageInfoOfDetailTable.pageIndex;
    detailTableGetRequest.pageSize = this.pageInfoOfDetailTable.pageSize;
    detailTableGetRequest.sortOrder = this.sortInfoOfDetailTable;
    return detailTableGetRequest;
  }

  private clearDetailTable() {
    this.clearTableFilter(this.detailTable);
    this.dataOfDetailTable = [];
    this.selectedRowOfDetailTable = null;
    this.pageInfoOfDetailTable.totalRecords = 0;
    this.pageInfoOfDetailTable.totalPages = 0;
  }

  private setDetailDataByServiceResponse(response: PageResp<DOAbnormalTableDetailData>) {
    this.clearTableFilter(this.detailTable);
    // Update Table
    this.dataOfDetailTable = deepCopy(response.content) ?? [];

    // Change page Info
    this.pageInfoOfDetailTable.totalRecords = response.totalElements;
    this.pageInfoOfDetailTable.totalPages = this.pageInfoOfDetailTable.totalRecords / this.pageInfoOfDetailTable.pageSize;
  }

  private getAbnormalItemTableData() {
    this.isAbnormalItemTableLoading = true;
    this.restoreAbnormalItemInternalData();

    let abnormalItemTableGetRequest: DOAbnormalTableAbnormalItemGetRequest = this.createAbnormalItemGetRequest();
    this.doAbnormalService.findDOAbnormalItem(abnormalItemTableGetRequest).subscribe({
      next: (response) => {
        this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
        if (!isNullOrEmpty(response) && !isNullOrEmpty(response.content)) {
          this.setAbnormalItemDataByServiceResponse(response);
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.clearAbnormalItemTable();
        this.toastService.error(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Failure.GetDataFail') + response.status);
      },
      complete: () => {
        this.isAbnormalItemTableLoading = false;
      }
    })
  }

  private createAbnormalItemGetRequest(): DOAbnormalTableAbnormalItemGetRequest {
    let abnormalItemTableGetRequest: DOAbnormalTableAbnormalItemGetRequest = new DOAbnormalTableAbnormalItemGetRequest();
    abnormalItemTableGetRequest.moNo = this.selectedRowOfHeaderTable?.moNo ?? '';
    abnormalItemTableGetRequest.moItemSeqNo = this.selectedRowOfDetailTable?.seqNo ?? null;
    abnormalItemTableGetRequest.pageIndex = this.pageInfoOfAbnormalItemTable.pageIndex;
    abnormalItemTableGetRequest.pageSize = this.pageInfoOfAbnormalItemTable.pageSize;
    abnormalItemTableGetRequest.sortOrder = this.sortInfoOfAbnormalItemTable;
    return abnormalItemTableGetRequest;
  }

  private setAbnormalItemDataByServiceResponse(response: PageResp<DOAbnormalTableAbnormalItemData>) {
    this.clearTableFilter(this.abnormalItemTable);
    // Update Table
    this.dataOfAbnormalItemTable = deepCopy(response.content) ?? [];
    this.backupDataOfAbnormalItemTable = deepCopy(this.dataOfAbnormalItemTable) ?? [];
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];

    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable)

    if (this.isAbnormalItemTableInEditMode) {
      this.headerTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    }

    // Change page Info
    this.pageInfoOfAbnormalItemTable.totalRecords = response.totalElements;
    this.pageInfoOfAbnormalItemTable.totalPages = this.pageInfoOfAbnormalItemTable.totalRecords / this.pageInfoOfAbnormalItemTable.pageSize;
  }

  private clearTableFilter(table: Table) {
    table.clearFilterValues();
    table.filteredValue = null;
    table.saveState();
  }

  private clearAbnormalItemTable() {
    this.clearTableFilter(this.abnormalItemTable);
    this.dataOfAbnormalItemTable = [];
    this.backupDataOfAbnormalItemTable = [];
    this.selectedRowOfAbnormalItemTable = null;
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.pageInfoOfAbnormalItemTable.totalRecords = 0;
    this.pageInfoOfAbnormalItemTable.totalPages = 0;
  }

  resetSearchForm() {
    this.etdDt.ngOnInit();
    this.searchFormGroup.reset();
    this.searchFormGroup.controls['orderQueryScope'].setValue(OrderQueryScopeEnum.personal);
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'etdDt':
        this.searchFormGroup.controls['etd'].setValue([date.startDate, date.endDate]);
        break;
    }
  }


  //#endregion Search Form Function

  //#region Table Common Function

  isAbleToEdit(): boolean {
    return !isNullOrEmpty(this.selectedRowOfHeaderTable)

  }

  isAbleToUpload(): boolean {
    return !isNullOrEmpty(this.selectedRowOfHeaderTable)
      && this.checkedRowOfDetailTable.length > 0
  }

  getWaitingReferenceDescByItsCode(waitingReferenceCode: string): string | null {
    return this.waitingReferenceOptions.find(waitingReferenceOptions =>
      waitingReferenceOptions.value == waitingReferenceCode)?.label ?? null;
  }

  //#endregion Table Common Function

  //#region Header Table Function

  async askConfirmationForSendNotification() {
    let secondConfirmationMessage: string | null = await new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Table.Header.Confirm.Notify'),
        icon: 'pi pi-info-circle',
        accept: () => {
          resolve(this.getNotificationSecondConfirmationMessage())
        }
      });
    });

    if (secondConfirmationMessage) {
      this.askSecondConfirmationForSendNotification(secondConfirmationMessage)
    }
    else {
      this.sendNotification();
    }
  }

  async askConfirmationForReplyNotification() {
    let secondConfirmationMessage: string | null = await new Promise((resolve) => {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Table.Header.Confirm.Reply'),
        icon: 'pi pi-info-circle',
        accept: () => {
          resolve(this.getReplySecondConfirmationMessage());
        }
      });
    });

    if (secondConfirmationMessage) {
      this.askSecondConfirmationForReplyNotification(secondConfirmationMessage)
    }
    else {
      this.replyNotification();
    }
  }

  saveDataChangesOnHeaderTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Table.Header.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.checkUpdatedWaitingReference();
        if (this.updatedHeaderList.length > 0) {
          let headerUpdateRequest: DOAbnormalTableHeaderUpdateRequest = this.createRequestForUpdateHeader();

          this.isHeaderTableLoading = true;
          this.doAbnormalService.updateHeader(headerUpdateRequest).subscribe({
            next: () => {
              this.getHeaderTableData();
              this.toastService.success(this.translateService.instant('DOAbnormal.Table.Header.Toast.Success.SaveSuccess'));
            },
            error: response => {
              this.toastService.error(this.translateService.instant('DOAbnormal.Table.Header.Toast.Failure.SaveFail') + response.status);
            },
            complete: () => {
              this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
              this.isHeaderTableInEditMode = false;
              this.isHeaderTableLoading = false;
            }
          });
        }
      }
    });
  }

  restoreDataOnHeaderTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Table.Header.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreHeader();
        this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
        this.toastService.success(this.translateService.instant('DOAbnormal.Table.Header.Toast.Success.RestoreSuccess'))
      }
    })
  }

  switchEditModeOnHeaderTable() {
    if (this.isHeaderTableInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Table.Header.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isHeaderTableInEditMode = false;
          this.restoreHeader();
          this.toastService.success(this.translateService.instant('DOAbnormal.Table.Header.Toast.Success.EditingCancelSuccess'))
        }
      })
    }
    else {
      this.isHeaderTableInEditMode = true;
      if (!isNullOrEmpty(this.selectedRowOfHeaderTable)) {
        this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
      }
    }
  }

  toggleAllRowCheckboxOnHeaderTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfHeaderTable.writeValue(!this.headerCheckboxOfHeaderTable.checked)
    }

    this.rowCheckboxesOfHeaderTable.forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfHeaderTable.checked());
    });

    this.checkedRowOfHeaderTable = this.headerCheckboxOfHeaderTable.checked() ? deepCopy(this.dataOfheaderTable) ?? [] : [];
  }

  toggleRowCheckboxOnHeaderTable(event: any, rowData: DOAbnormalTableHeaderData) {
    if (event.checked) {
      this.checkedRowOfHeaderTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfHeaderTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfHeaderTable.splice(removedIndex, 1);
    }
  }

  selectRowOnHeaderTable(rowData: DOAbnormalTableHeaderData) {
    this.selectedRowOfHeaderTable = rowData;

    // Keep the selectedHeaderTableRow variable is pointing at the user's selected row
    // Whether is select or deselect
    if (this.isReselectHeaderTableRow()) {
      this.updateHeaderTableHighlight(this.previousSelectedRowOfHeaderTable);
      return;
    }

    if (this.isHeaderTableInEditMode) {
      // Change the current selected Header row to the user's selected Header row
      this.headerTable.cancelRowEdit(this.previousSelectedRowOfHeaderTable);
      this.headerTable.initRowEdit(this.selectedRowOfHeaderTable);
    }

    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;
    this.getDetailTableData();
    this.getAbnormalItemTableData();
  }

  pagingOnHeaderTable(event: { first: number, rows: number }) {
    this.pageInfoOfHeaderTable.pageSize = event.rows;
    this.pageInfoOfHeaderTable.pageIndex = event.first / event.rows;

    this.getHeaderTableData();
  }

  sortingOnHeaderTable(event: { field: string, order: number }) {
    if (this.dataOfheaderTable.length > 0) {
      if (event.field == 'eta' || event.field == 'etd') {
        this.sortInfoOfHeaderTable.property = event.field.toUpperCase();
      }
      else if (event.field == 'customer') {
        this.sortInfoOfHeaderTable.property = 'consigneeKey'
      }
      else if (event.field == 'waitingReference') {
        this.sortInfoOfHeaderTable.property = 'waitingReason'
      }
      else {
        this.sortInfoOfHeaderTable.property = event.field
      }
      this.sortInfoOfHeaderTable.direction = event.order;
      this.getHeaderTableData();
    }
  }

  async setHeaderPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfHeaderTable.pageSize = event.rows;
  }

  private createRequestForUpdateHeader(): DOAbnormalTableHeaderUpdateRequest {
    let headerUpdateRequest: DOAbnormalTableHeaderUpdateRequest = new DOAbnormalTableHeaderUpdateRequest();
    headerUpdateRequest.updatedHeaders = this.updatedHeaderList;
    headerUpdateRequest.userName = this.userService.userInfo.userName;
    headerUpdateRequest.operationDate = new Date();
    return headerUpdateRequest;
  }

  private getNotificationSecondConfirmationMessage(): string | null {
    let notifiedDoNos: string[] = this.checkNotifiedAbnormalDO();
    return this.createWarningMessageForNotification(notifiedDoNos);
  }

  private checkNotifiedAbnormalDO(): string[] {
    let notifiedAbnormalDONos: string[] = [];
    for (let doAbnormal of this.checkedRowOfHeaderTable) {
      if (doAbnormal.notifyFlag === 1) {
        notifiedAbnormalDONos.push(doAbnormal.doNo);
      }
    }
    return notifiedAbnormalDONos;
  }

  private createWarningMessageForNotification(notifiedDONos: string[]): string | null {
    let message = ''
    if (notifiedDONos.length > 0) {
      message += this.translateService.instant('DOAbnormal.Table.Header.Toast.Warning.HadNotified');
      for (let doNo of notifiedDONos) {
        message += `\n${doNo}`;
      }
    }

    return message != '' ? message : null;
  }

  private askSecondConfirmationForSendNotification(message: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: message,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.sendNotification();
      }
    });
  }

  private sendNotification() {
    this.isHeaderTableLoading = true;
    let doAbnormalMailRequest: DOAbnormalMailRequest = this.createDOAbnormalMailRequest();
    this.doAbnormalService.sendNotification(doAbnormalMailRequest, this.laasSetting.language).subscribe({
      next: () => {
        this.getHeaderTableData();
        this.toastService.success(this.translateService.instant('DOAbnormal.Table.Header.Toast.Success.NotifySuccess'));
      },
      error: err => {
        console.log('err' + err);
        console.log('err' + err.error.category);
        if (err.error.category == this.ERROR_CODE_CATEGORY) {
          console.log('err' + err.error.category);
          this.toastErrorMessage(err.error);
        }
        else {
          this.toastService.error(this.translateService.instant('DOAbnormal.Table.Header.Toast.Failure.NotifyFail'));
        }
        this.isHeaderTableLoading = false;
      },
      complete: () => {
        this.isHeaderTableLoading = false;
      }
    })
  }

  private getReplySecondConfirmationMessage() {
    let repliedAbnormalDONos: string[] = this.checkRepliedAbnormalDO();
    return this.createWarningMessageForReplyNotification(repliedAbnormalDONos);
  }

  private checkRepliedAbnormalDO(): string[] {
    let repliedAbnormalDONos: string[] = [];
    for (let doAbnormal of this.checkedRowOfHeaderTable) {
      if (doAbnormal.replyFlag === 1) {
        repliedAbnormalDONos.push(doAbnormal.doNo);
      }
    }
    return repliedAbnormalDONos;
  }

  private createWarningMessageForReplyNotification(repliedAbnormalDONos: string[]): string | null {
    let message = ''
    if (repliedAbnormalDONos.length > 0) {
      message += this.translateService.instant('DOAbnormal.Table.Header.Toast.Warning.HadReplied');
      for (let doNo of repliedAbnormalDONos) {
        message += `\n${doNo}`;
      }
    }

    return message != '' ? message : null;
  }

  private askSecondConfirmationForReplyNotification(message: string) {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: message,
      icon: 'pi pi-info-circle',
      accept: () => {
        this.replyNotification();
      }
    });
  }

  private replyNotification() {
    this.isHeaderTableLoading = true;
    let doAbnormalMailRequest: DOAbnormalMailRequest = this.createDOAbnormalMailRequest();
    this.doAbnormalService.replyNotification(doAbnormalMailRequest, this.laasSetting.language).subscribe({
      next: () => {
        this.getHeaderTableData();
        this.toastService.success(this.translateService.instant('DOAbnormal.Table.Header.Toast.Success.ReplySuccess'));
      },
      error: response => {
        if (response.error.category == this.ERROR_CODE_CATEGORY) {
          this.toastErrorMessage(response.error)
        }
        else {
          this.toastService.error(this.translateService.instant('DOAbnormal.Table.Header.Toast.Failure.ReplyFail') + response.status);
        }
        this.isHeaderTableLoading = false;
      },
      complete: () => {
        this.isHeaderTableLoading = false;
      }
    })
  }

  private createDOAbnormalMailRequest(): DOAbnormalMailRequest {
    let doAbnormalMailRequest = new DOAbnormalMailRequest();
    let doNos: string[] = [];
    let moNos: string[] = [];
    let facilities: string[] = [];

    for (let doAbnormal of this.checkedRowOfHeaderTable) {
      doNos.push(doAbnormal.doNo)
      moNos.push(doAbnormal.moNo)
      facilities.push(doAbnormal.facility)
    }
    doAbnormalMailRequest.doNos = doNos;
    doAbnormalMailRequest.moNos = moNos;
    doAbnormalMailRequest.facilities = facilities;
    doAbnormalMailRequest.userName = this.userService.userInfo.userName;
    doAbnormalMailRequest.operationDate = new Date();
    return doAbnormalMailRequest;
  }

  private checkUpdatedWaitingReference() {
    for (let i = 0; i < this.backupDataOfHeaderTable.length; i++) {
      if (this.dataOfheaderTable[i].waitingReference !== this.backupDataOfHeaderTable[i].waitingReference) {
        this.addToHeaderUpdateList(this.dataOfheaderTable[i]);
      }
    }
  }

  private addToHeaderUpdateList(headerData: DOAbnormalTableHeaderData) {
    let updateHeaderBean = new DOAbnormalTableHeaderUpdateBean();
    updateHeaderBean.moNo = headerData.moNo;
    updateHeaderBean.waitingReference = headerData.waitingReference ?? null;
    this.updatedHeaderList.push(updateHeaderBean);
  }

  // Check if user reselect selected Header row
  private isReselectHeaderTableRow(): boolean {
    return this.previousSelectedRowOfHeaderTable != null
      && this.previousSelectedRowOfHeaderTable.dataKey === this.selectedRowOfHeaderTable!.dataKey
  }

  private restoreHeader() {
    this.restoreHeaderTable();
    this.restoreHeaderInternalData();
  }

  private restoreHeaderTable() {
    this.dataOfheaderTable = deepCopy(this.backupDataOfHeaderTable)!;
    this.cancelHeaderTableEdit();
  }

  // Cancel current Header table's row editing
  private cancelHeaderTableEdit() {
    this.headerTable.cancelRowEdit(this.selectedRowOfHeaderTable);
    this.selectedRowOfHeaderTable = this.dataOfheaderTable[0];
    this.previousSelectedRowOfHeaderTable = this.selectedRowOfHeaderTable;

    // Avoid the highlighted part leave on the previous Header row
    this.updateHeaderTableHighlight(this.selectedRowOfHeaderTable);
  }

  private restoreHeaderInternalData(): void {
    // Clear user changed action in Header table
    this.checkedRowOfHeaderTable = [];
    this.headerCheckboxOfHeaderTable.writeValue(false);

    this.updatedHeaderList = [];
    this.headerTable.resetScrollTop();
  }

  // Control the selection highlight to the specific Header row
  private updateHeaderTableHighlight(selectedRow: DOAbnormalTableHeaderData | null): void {
    if (!selectedRow) {
      return;
    }
    this.headerTable.selection = selectedRow;
    this.headerTable.selectionKeys = {};
    this.headerTable.selectionKeys[selectedRow.dataKey] = 1;
    this.headerTable.tableService.onSelectionChange();
  }

  //#endregion Header Table Function

  //#region Detail Table Function

  showUploadFileDialog() {
    this.isShowNewAbnormalItemDialog = true;
    this.keepDialogToFullScreenInMobileMode(this.newAbnormalItemDialog);
    this.dataOfRelatedDetailTable = deepCopy(this.checkedRowOfDetailTable) ?? [];
  }

  toggleAllRowCheckboxOnDetailTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfDetailTable.writeValue(!this.headerCheckboxOfDetailTable.checked)
    }

    this.rowCheckboxesOfDetailTable.forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfDetailTable.checked());
    })

    this.checkedRowOfDetailTable = this.headerCheckboxOfDetailTable.checked() ? deepCopy(this.dataOfDetailTable) ?? [] : [];
  }

  toggleRowCheckboxOnDetailTable(event: any, rowData: DOAbnormalTableDetailData) {
    if (event.checked) {
      this.checkedRowOfDetailTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfDetailTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfDetailTable.splice(removedIndex, 1);
    }
  }

  selectRowOnDetailTable() {
    this.getAbnormalItemTableData();
  }

  pagingOnDetailTable(event: { first: number, rows: number }) {
    this.pageInfoOfDetailTable.pageSize = event.rows;
    this.pageInfoOfDetailTable.pageIndex = event.first / event.rows;

    this.getDetailTableData();
  }

  sortingOnDetailTable(event: { field: string, order: number }) {
    if (this.dataOfDetailTable.length > 0) {
      this.sortInfoOfDetailTable.property = event.field;
      this.sortInfoOfDetailTable.direction = event.order;

      this.getDetailTableData();
    }
  }

  async setDetailPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfDetailTable.pageSize = event.rows;
  }

  private restoreDetailInternalData(): void {
    // Clear user changed action
    this.checkedRowOfDetailTable = [];
    this.headerCheckboxOfDetailTable.writeValue(false);

    if (!this.isInDesktopMode) {
      this.detailTable.resetScrollTop();
    }
  }

  //#endregion Detail Table Function

  //#region Abnormal Item Table Function

  addRowOnAbnormalItemTable() {
    if (!this.isUserInputValidOnAbnormalItemTable(this.previousSelectedRowOfAbnormalItemTable)) {
      return;
    }

    // Add a new row to AbnormalItem table's first row
    let newAbnormalItemData = new DOAbnormalTableAbnormalItemData();
    newAbnormalItemData.createUser = this.userService.userInfo.userName;
    newAbnormalItemData.createDt = new Date();
    newAbnormalItemData.updateUser = this.userService.userInfo.userName;
    newAbnormalItemData.updateDt = new Date();
    newAbnormalItemData.dataKey = `--${this.newAbnormalItemDataKeyId++}`;
    newAbnormalItemData.doNo = this.selectedRowOfHeaderTable?.doNo ?? "";
    newAbnormalItemData.moNo = this.selectedRowOfHeaderTable?.moNo ?? "";

    this.dataOfAbnormalItemTable.splice(0, 0, newAbnormalItemData)

    this.clearAbnormalItemTableEdit();

    this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
  }

  deleteRowOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Table.AbnormalItem.Confirm.Delete'),
      icon: 'pi pi-info-circle',
      accept: () => {
        if (this.checkedRowOfAbnormalItemTable.length > 0) {
          this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
          this.removeRemoveFromAbnormalItemTable();

          if (this.dataOfAbnormalItemTable.length <= 0) {
            this.headerCheckboxOfAbnormalItemTable.writeValue(false);
          }

          this.checkedRowOfAbnormalItemTable = [];
          this.toastService.success(this.translateService.instant("DOAbnormal.Table.AbnormalItem.Toast.Success.DeleteSuccess"));
        }
      }
    })
  }

  saveDataChangesOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Table.AbnormalItem.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        if (!this.isUserInputValidOnAbnormalItemTable(this.selectedRowOfAbnormalItemTable)) {
          return;
        }

        this.isAbnormalItemTableLoading = true;
        this.checkAbnormalItemTableChanges();
        const request: DOAbnormalTableAbnormalItemSaveRequest = this.createAbnormalItemSaveRequest();

        this.doAbnormalService.saveAbnormalItemChanges(request).subscribe({
          next: () => {
            this.getDetailTableData();
            this.getAbnormalItemTableData();
            this.toastService.success(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Success.SaveSuccess'));
          },
          error: (response: { status: number; }) => {
            this.toastService.error(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Failure.SaveFail') + response.status);
          },
          complete: () => {
            this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
            this.isAbnormalItemTableInEditMode = false;
            this.isAbnormalItemTableLoading = false;
            this.newAbnormalItemList = [];
            this.updatedAbnormalItemList = [];
          }
        });
      }
    })
  }

  restoreDataOnAbnormalItemTable() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Table.AbnormalItem.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreAbnormalItem();
        this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
        this.toastService.success(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Success.RestoreSuccess'))
      }
    })
  }

  switchEditModeOnAbnormalItemTable() {
    if (this.isAbnormalItemTableInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Table.AbnormalItem.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isAbnormalItemTableInEditMode = false;
          this.restoreAbnormalItem();
          this.toastService.success(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Success.EditingCancelSuccess'))
        }
      })
    }
    else {
      this.isAbnormalItemTableInEditMode = true;
      if (!isNullOrEmpty(this.selectedRowOfAbnormalItemTable)) {
        this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
      }
    }
  }

  toggleAllRowCheckboxOnAbnormalItemTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfAbnormalItemTable.writeValue(!this.headerCheckboxOfAbnormalItemTable.checked)
    }

    this.rowCheckboxesOfAbnormalItemTable.forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfAbnormalItemTable.checked());
    })

    this.checkedRowOfAbnormalItemTable = this.headerCheckboxOfAbnormalItemTable.checked() ? deepCopy(this.dataOfAbnormalItemTable) ?? [] : [];

  }

  toggleRowCheckboxOnAbnormalItemTable(event: any, rowData: DOAbnormalTableAbnormalItemData) {
    if (event.checked) {
      this.checkedRowOfAbnormalItemTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfAbnormalItemTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfAbnormalItemTable.splice(removedIndex, 1);
    }
  }

  reselectAfterEnterKeyDown(event: any) {
    if (event.originalEvent.key == 'Enter') {
      this.selectedRowOfAbnormalItemTable = event.data
      this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
    }
  }

  selectRowOnAbnormalItemTable(rowData: DOAbnormalTableAbnormalItemData) {
    // Keep the selectedRow variable is pointing at the user's selected row
    // Whether is select or deselect
    this.selectedRowOfAbnormalItemTable = rowData;

    if (this.isReselectAbnormalItemTableRow()) {
      this.updateAbnormalItemTableHighlight(this.previousSelectedRowOfAbnormalItemTable);
      return;
    }

    if (this.isAbnormalItemTableInEditMode) {
      if (!this.isUserInputValidOnAbnormalItemTable(this.previousSelectedRowOfAbnormalItemTable)) {
        // Rollback the selected row to the row which doesn't fill the required data well
        this.selectedRowOfAbnormalItemTable = this.previousSelectedRowOfAbnormalItemTable;
        this.updateAbnormalItemTableHighlight(this.previousSelectedRowOfAbnormalItemTable);
        return;
      }
      // Change the current selected row to the user's selected row
      this.abnormalItemTable.cancelRowEdit(this.previousSelectedRowOfAbnormalItemTable);
      this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    }
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
  }

  pagingOnAbnormalItemTable(event: { first: number, rows: number }) {
    this.pageInfoOfAbnormalItemTable.pageSize = event.rows;
    this.pageInfoOfAbnormalItemTable.pageIndex = event.first / event.rows;
    this.getAbnormalItemTableData();

  }

  sortingOnAbnormalItemTable(event: { field: string, order: number }) {
    if (this.dataOfAbnormalItemTable.length > 0) {
      this.sortInfoOfAbnormalItemTable.property = event.field;
      this.sortInfoOfAbnormalItemTable.direction = event.order;
      this.getAbnormalItemTableData();
    }
  }

  async setAbnormalItemPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfoOfAbnormalItemTable.pageSize = event.rows;
  }

  showAbnormalItemFiles(event: Event, rowData: DOAbnormalTableAbnormalItemData) {
    this.stopBubblingPhases(event);

    this.selectRowOnAbnormalItemTable(rowData)
    if (this.selectedRowOfAbnormalItemTable!.dataKey != rowData.dataKey) {
      return;
    }

    this.fileDocIdOfCurrentAbnormalItem = deepCopy(this.selectedRowOfAbnormalItemTable?.docIds) ?? [];
    this.isShowAbnormalItemFileDialog = true;
    this.keepDialogToFullScreenInMobileMode(this.abnormalItemFileDialog);
    this.getAbnormalItemFile();
  }

  private isUserInputValidOnAbnormalItemTable(rowData: DOAbnormalTableAbnormalItemData | null): boolean {
    if (rowData) {
      if (
        isNullOrEmpty(rowData.waitingReference)
      ) {
        this.toastService.warn(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Warning.EmptyData'));
        return false;
      }

      if (
        rowData.abnormalQty != null && rowData.abnormalQty < 0
      ) {
        this.toastService.warn(this.translateService.instant('DOAbnormal.Table.AbnormalItem.Toast.Warning.NegativeAbnormalQty'));
        return false;
      }
    }
    return true;
  }

  private removeRemoveFromAbnormalItemTable() {
    for (let rowOfRemove of this.checkedRowOfAbnormalItemTable) {
      const indexOfRow = this.dataOfAbnormalItemTable.findIndex(data => data.dataKey == rowOfRemove.dataKey);
      if (indexOfRow > - 1) {
        this.dataOfAbnormalItemTable.splice(indexOfRow, 1);
        this.addDeletedListOfAbnormalItemTable(rowOfRemove.seqNo);
      }
    }
    this.changeSelectedRowToFirstRowOnAbnormalItemtable();
  }

  private addDeletedListOfAbnormalItemTable(deletedSeqNo: number | null) {
    if (deletedSeqNo != null) {
      this.deletedSeqNoGroupOfAbnormalItemTable.push(deletedSeqNo)
    }
  }

  private changeSelectedRowToFirstRowOnAbnormalItemtable() {
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;
    this.abnormalItemTable.initRowEdit(this.selectedRowOfAbnormalItemTable);
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
  }

  private checkAbnormalItemTableChanges() {
    let changedDataIndex = 0;

    // Check if any data inside Abnormal Item table
    if (changedDataIndex < this.dataOfAbnormalItemTable.length) {

      for (const abnormalItemData of this.dataOfAbnormalItemTable) {
        // Check if any added row by dataKey property
        // Added row's dataKey format : --id
        if (abnormalItemData.dataKey[0] != '-') {
          break;
        }
        this.recordNewAbnormalItem(abnormalItemData);
        changedDataIndex++;
      }

      // Reverse for maintain order of user adding new row
      this.newAbnormalItemList.reverse();

      // Compare backup table data to current table data
      for (const backupAbnormalItemData of this.backupDataOfAbnormalItemTable) {
        if (this.deletedSeqNoGroupOfAbnormalItemTable.indexOf(backupAbnormalItemData.seqNo) == -1) {
          if (JSON.stringify(this.dataOfAbnormalItemTable[changedDataIndex]) != JSON.stringify(backupAbnormalItemData)) {
            this.recordUpdatedAbnormalItem(this.dataOfAbnormalItemTable[changedDataIndex]);
          }
          changedDataIndex++;
        }
      }
    }
  }

  private recordNewAbnormalItem(newAbnormalItem: DOAbnormalTableAbnormalItemData) {
    this.newAbnormalItemList.push(newAbnormalItem);
  }

  private recordUpdatedAbnormalItem(updatedAbnormalItem: DOAbnormalTableAbnormalItemData) {
    this.updatedAbnormalItemList.push(updatedAbnormalItem);
  }

  // Check if user reselect selected Abnormal Item row
  private isReselectAbnormalItemTableRow(): boolean {
    return this.previousSelectedRowOfAbnormalItemTable != null
      && this.previousSelectedRowOfAbnormalItemTable.dataKey === this.selectedRowOfAbnormalItemTable!.dataKey
  }

  private keepDialogToFullScreenInMobileMode(dialog: Dialog) {
    if (!this.isInDesktopMode()) {
      dialog.maximizable = false;
      dialog.maximized = false;
      dialog.maximize();
      dialog.disableModality();
    }
  }

  // Cancel current AbnormalItem table's row editing
  private clearAbnormalItemTableEdit() {
    this.abnormalItemTable.cancelRowEdit(this.selectedRowOfAbnormalItemTable);
    this.selectedRowOfAbnormalItemTable = this.dataOfAbnormalItemTable[0];
    this.previousSelectedRowOfAbnormalItemTable = this.selectedRowOfAbnormalItemTable;

    //Avoid the highlighted part leave on the previous row
    this.updateAbnormalItemTableHighlight(this.selectedRowOfAbnormalItemTable);
  }

  private restoreAbnormalItem() {
    this.restoreAbnormalItemTable();
    this.restoreAbnormalItemInternalData();
  }

  private restoreAbnormalItemTable() {
    this.dataOfAbnormalItemTable = deepCopy(this.backupDataOfAbnormalItemTable)!;
    this.clearAbnormalItemTableEdit();
  }

  private restoreAbnormalItemInternalData(): void {
    // Clear user changed action
    this.checkedRowOfAbnormalItemTable = [];
    this.headerCheckboxOfAbnormalItemTable.writeValue(false);

    this.newAbnormalItemDataKeyId = 0;
    this.newAbnormalItemList = [];
    this.updatedAbnormalItemList = [];
    this.deletedSeqNoGroupOfAbnormalItemTable = [];

    if (!this.isInDesktopMode) {
      this.abnormalItemTable.resetScrollTop();
    }
  }

  private createAbnormalItemSaveRequest(): DOAbnormalTableAbnormalItemSaveRequest {
    let request = new DOAbnormalTableAbnormalItemSaveRequest();
    request.userName = this.userService.userInfo.userName;
    request.operationDate = new Date();
    request.newDOAbnormalItems = this.newAbnormalItemList;
    request.updatedDOAbnormalItems = this.updatedAbnormalItemList;
    request.deletedDOAbnormalItemSeqNos = this.deletedSeqNoGroupOfAbnormalItemTable;
    return request;
  }

  // Control the selection highlighting back to the row
  private updateAbnormalItemTableHighlight(selectedRow: DOAbnormalTableAbnormalItemData | null): void {
    if (!selectedRow) {
      return;
    }
    this.abnormalItemTable.selection = selectedRow;
    this.abnormalItemTable.selectionKeys = {};
    this.abnormalItemTable.selectionKeys[selectedRow.dataKey] = 1;
    this.abnormalItemTable.tableService.onSelectionChange();
  }

  //#endregion Abnormal Item Table Function

  //#region New Abnormal Item Dialog Function

  visibleChangeOfNewAbnormalItemDialog(visible: boolean) {
    if (!visible) {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.clearDialog();
        },
        reject: () => {
          this.isShowNewAbnormalItemDialog = true;
        }
      })
    }
  }

  clearDialog() {
    this.newAbnormalItemDialogFormGroup.reset();
    this.dataOfFileTable = [];
    this.fileTable.first = 0;
    this.restoreRelatedDetailTableInternalData();
  }

  //#region File Table Function

  removeChosenFile(rowIndex: number) {
    this.dataOfFileTable.splice(rowIndex, 1);
    this.fileTable.totalRecords = this.dataOfFileTable.length
  }

  onNewFileFileSelect(fileInput: HTMLInputElement) {
    let files = fileInput.files;
    if (!files) {
      fileInput.value = "";
      return;
    }

    const MAX_SIZE_MB = 50 * 1024 * 1024;
    let fileDatas: File[] = [];
    let currentFileSize = this.dataOfFileTable.reduce((total, file) => total + file.size, 0);
    let newFileSize = Array.from(files).reduce((total, file) => total + file.size, 0);

    if (currentFileSize + newFileSize > MAX_SIZE_MB) {
      this.toastService.warn(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Warning.FileSizeLimit'));
    } else {
      Array.prototype.forEach.call(files, file => {
        if (!this.isFileSelectedInFileTable(file)) {
          fileDatas.push(file);
        }
      });
      this.dataOfFileTable = this.dataOfFileTable.concat(fileDatas)
    }

    fileInput.value = "";
  }

  private isFileSelectedInFileTable(file: File): boolean {
    for (let fileData of this.dataOfFileTable) {
      if ((fileData.name + fileData.type + fileData.size) === (file.name + file.type + file.size)) {
        return true;
      }
    }
    return false;
  }

  //#endregion File Table Function

  //#region Related Detail Table Function

  toggleAllRowCheckboxOnRelatedDetailTable() {
    if (!this.isInDesktopMode()) {
      this.headerCheckboxOfRelatedDetailTable.writeValue(!this.headerCheckboxOfRelatedDetailTable.checked)
    }

    this.rowCheckboxesOfRelatedDetailTable.forEach(checkbox => {
      checkbox.writeValue(this.headerCheckboxOfRelatedDetailTable.checked());
    })

    this.checkedRowOfRelatedDetailTable = this.headerCheckboxOfRelatedDetailTable.checked() ? deepCopy(this.dataOfRelatedDetailTable) ?? [] : [];

  }

  toggleRowCheckboxOnRelatedDetailTable(event: any, rowData: DOAbnormalTableDetailData) {
    if (event.checked) {
      this.checkedRowOfRelatedDetailTable.push(rowData)
    }
    else {
      const removedIndex = this.checkedRowOfRelatedDetailTable.findIndex(checkedRowData => checkedRowData.dataKey == rowData.dataKey)
      this.checkedRowOfRelatedDetailTable.splice(removedIndex, 1);
    }
  }

  private restoreRelatedDetailTableInternalData() {
    this.checkedRowOfRelatedDetailTable = [];
    this.headerCheckboxOfRelatedDetailTable.writeValue(false);
  }

  //#endregion Related Detail Table Function

  createNewAbnormalItem() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Confirm.Upload'),
      icon: 'pi pi-info-circle',
      accept: async () => {
        if (!this.isAbleToCreateNewAbnormalItem()) {
          return;
        }

        this.isNewAbnormalItemDialogLoading = true;
        let createAbnormalItemRequest = await this.createRequestForCreateAbnormalItem();
        this.doAbnormalService.createDOAbnormalItem(createAbnormalItemRequest).subscribe({
          next: () => {
            this.clearDialog();
            this.isShowNewAbnormalItemDialog = false;

            this.restoreDetailInternalData();
            this.toggleAllRowCheckboxOnDetailTable();
            this.getDetailTableData();
            this.getAbnormalItemTableData();
            this.toastService.success(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Success.UploadSuccess'))
          },
          error: (response) => {
            if (response.error != null && response.error.category == this.ERROR_CODE_CATEGORY) {
              this.toastErrorMessage(response.error)
            }
            else {
              this.toastService.error(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Failure.UploadFail') + response.status);
            }
            this.isNewAbnormalItemDialogLoading = false;
          },
          complete: () => {
            this.isNewAbnormalItemDialogLoading = false;
          }
        })
      }
    });
  }

  private isAbleToCreateNewAbnormalItem(): boolean {
    if (
      isNullOrEmpty(this.newAbnormalItemDialogFormGroup.value.waitingReference)
    ) {
      this.toastService.warn(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Warning.EmptyData'));
      return false;
    }

    if (
      this.newAbnormalItemDialogFormGroup.value.abnormalQty != null
      && this.newAbnormalItemDialogFormGroup.value.abnormalQty < 0
    ) {
      this.toastService.warn(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Warning.NegativeAbnormalQty'));
      return false;
    }
    return true;
  }

  private async createRequestForCreateAbnormalItem(): Promise<DOAbnormalCreateAbnormalItemRequest> {
    let createAbnormalItemRequest = new DOAbnormalCreateAbnormalItemRequest()
    createAbnormalItemRequest.userName = this.userService.userInfo.userName;
    createAbnormalItemRequest.operationDate = new Date();
    createAbnormalItemRequest.doNo = this.selectedRowOfHeaderTable?.doNo ?? "";
    createAbnormalItemRequest.moNo = this.selectedRowOfHeaderTable?.moNo ?? "";
    createAbnormalItemRequest.abnormalQty = this.newAbnormalItemDialogFormGroup.value.abnormalQty;
    createAbnormalItemRequest.waitingReference = this.newAbnormalItemDialogFormGroup.value.waitingReference;
    createAbnormalItemRequest.waitingReferenceDesc = this.newAbnormalItemDialogFormGroup.value.waitingReferenceDesc;
    createAbnormalItemRequest.relatedDetailSeqNos = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.seqNo);
    createAbnormalItemRequest.relatedDetailExternLineNos = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.externLineNo);
    createAbnormalItemRequest.relatedDetailSkus = this.checkedRowOfRelatedDetailTable.map(rowData => rowData.sku);
    createAbnormalItemRequest.newFiles = await this.convertToFileBase64Beans(this.dataOfFileTable);
    return createAbnormalItemRequest;
  }

  private async convertToFileBase64Beans(files: File[]): Promise<DOAbnormalItemFileBase64Bean[] | null> {
    if (files && files.length > 0) {
      let fileBase64Beans: DOAbnormalItemFileBase64Bean[] = [];
      for (let file of files) {
        let fileBase64: string | null = await this.convertFileToBase64(file);
        if (fileBase64 != null) {
          let fileBase64Bean = this.convertToFileBase64Bean(file, fileBase64);
          fileBase64Beans.push(fileBase64Bean);
        }
      }
      return fileBase64Beans;
    }
    return null;
  }

  private convertToFileBase64Bean(file: File, fileBase64: string): DOAbnormalItemFileBase64Bean {
    let fileNameArray = file.name.split('.');
    let fileExtension: string | null = fileNameArray.pop()!;
    let fileName = fileNameArray.join('.')!;

    if (fileName.length == 0) {
      fileName = fileExtension;
      fileExtension = null;
    }

    let fileBase64Bean = new DOAbnormalItemFileBase64Bean();
    fileBase64Bean.fileName = fileName;
    fileBase64Bean.fileExtension = fileExtension;
    fileBase64Bean.fileType = file.type;
    fileBase64Bean.fileBase64s = fileBase64;
    return fileBase64Bean;
  }

  //#endregion Dialog Function

  //#region Abnormal Item File Dialog Function

  visibleChangeOfAbnormalItemFileDialog(visible: boolean) {
    if (!visible) {
      this.confirmationService.confirm({
        header: this.translateService.instant('DOAbnormal.Confirm.Header'),
        message: this.translateService.instant('DOAbnormal.Dialog.AbnormalItemFile.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.onCloseAbnormalItemFileDialog();
        },
        reject: () => {
          this.isShowAbnormalItemFileDialog = true;
        }
      })
    }
  }

  transformToSafeUrl(url: string | null) {
    return url ? this.sanitizer.bypassSecurityTrustUrl(url) : '';
  }

  onFileClick(index: number) {
    if (this.isInDesktopMode()) {
      // Because Galleria follow the dialog's size
      // Below make galleria in full screen
      // but when close the galleria, restore the dialog to its original size
      let originalMaximized = this.abnormalItemFileDialog.maximized;
      this.abnormalItemFileDialog.maximized = false;
      this.abnormalItemFileDialog.maximize();
      this.abnormalItemFileDialog.disableModality();
      this.abnormalItemFileDialog.maximized = !originalMaximized;
    }

    this.isShowBigFile = true;
    this.indexOfGalleria = index;
  }

  visibleChangeOfGalleria() {
    if (this.isInDesktopMode()) {
      // Restore the dialog to its original size
      this.abnormalItemFileDialog.maximize();
      this.abnormalItemFileDialog.disableModality();
    }
  }

  async addFileToAbnormalItem(fileInput: HTMLInputElement) {
    let files = fileInput.files;
    if (!files || this.isExceedMaxSize(files)) {
      fileInput.value = "";
      return;
    }

    for (let i = 0; i < files.length; i++) {
      if (!this.isFileSelectedInAbnormalItemFile(files[i])) {
        let fileBase64 = await this.convertFileToBase64(files[i]);
        if (fileBase64) {
          let abnormalItemFile = this.convertToAbnormalItemFile(files[i], fileBase64);
          this.fileOfAbnormalItemFileDialog.splice(i, 0, abnormalItemFile);
          this.fileDocIdOfCurrentAbnormalItem.splice(i, 0, '');

          let abnormalItemFileBase64 = this.convertToFileBase64Bean(files[i], fileBase64);
          this.newAbnormalItemFileBase64s.push(abnormalItemFileBase64);
        }
      }
    }

    fileInput.value = "";
  }

  isExceedMaxSize(files: FileList): boolean {
    const MAX_SIZE_MB = 50 * 1024 * 1024;
    let totalFileSize = this.fileOfAbnormalItemFileDialog.reduce((total, file) => total + this.base64Size(file.fileDataUrl!), 0);
    let newFileSize = Array.from(files).reduce((total, file) => total + file.size, 0);

    if (totalFileSize + newFileSize > MAX_SIZE_MB) {
      this.toastService.warn(this.translateService.instant('DOAbnormal.Dialog.NewAbnormalItem.Toast.Warning.FileSizeLimit'));
      return true;
    }

    return false;
  }

  base64Size(base64: string): number {
    let padding = 0;
    if (base64.endsWith('==')) {
      padding = 2;
    } else if (base64.endsWith('=')) {
      padding = 1;
    }
    const base64Length = base64.length - padding;
    return (base64Length * 3) / 4;
  }

  deleteFileFromAbnormalItem(index: number) {
    let deletedDocId: string = this.fileDocIdOfCurrentAbnormalItem[index];
    this.fileDocIdOfCurrentAbnormalItem.splice(index, 1);
    this.fileOfAbnormalItemFileDialog.splice(index, 1);
    if (deletedDocId != '') {
      this.deletedAbnormalItemFileDocIds.push(deletedDocId);
    }
  }

  restoreAbnormalItemFileData() {
    this.fileDocIdOfCurrentAbnormalItem = deepCopy(this.selectedRowOfAbnormalItemTable?.docIds) ?? [];
    this.fileOfAbnormalItemFileDialog = deepCopy(this.backupFileOfAbnormalItemFileDialog) ?? [];
    this.clearUserOperationOnAbnormalFileDialog();
  }

  onSaveBtnClickOnAbnormalItemFileDialog() {
    this.confirmationService.confirm({
      header: this.translateService.instant('DOAbnormal.Confirm.Header'),
      message: this.translateService.instant('DOAbnormal.Dialog.AbnormalItemFile.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saveDataChangesOnAbnormalFileDialog();
      }
    })
  }

  isImageTypeFile(fileType: string): boolean {
    return this.getTypeClass(fileType) === this.getTypeClass("image/*")
  }

  isAbleToSaveAbnormalItemFileChange() {
    return (this.newAbnormalItemFileBase64s != null && this.newAbnormalItemFileBase64s.length > 0)
      || (this.deletedAbnormalItemFileDocIds != null && this.deletedAbnormalItemFileDocIds.length > 0)
  }

  isAbnormalItemFileDialogInEditMode(): boolean {
    return this.abnormalItemFileDialogMode === this.ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit;
  }

  private getAbnormalItemFile() {
    this.isAbnormalItemFileDialogLoading = true;
    let fileRequest: DOAbnormalItemFilesRequest = this.createfileGetRequest();
    this.getFileSubscribe = this.doAbnormalService.findFilesBySnGroup(fileRequest).subscribe({
      next: (response) => {
        if (response.files) {
          this.fileOfAbnormalItemFileDialog = [];
          this.setAbnormalItemFileDialogDataBy(response);
          this.backupFileOfAbnormalItemFileDialog = deepCopy(this.fileOfAbnormalItemFileDialog) ?? []
        }
      },
      complete: () => {
        this.isAbnormalItemFileDialogLoading = false;
      }
    })
  }

  private createfileGetRequest(): DOAbnormalItemFilesRequest {
    let fileRequest: DOAbnormalItemFilesRequest = new DOAbnormalItemFilesRequest();
    fileRequest.docIds = this.fileDocIdOfCurrentAbnormalItem;
    fileRequest.userName = this.userService.userInfo.userName;
    return fileRequest;

  }

  private setAbnormalItemFileDialogDataBy(response: DOAbnormalItemFileResponse) {
    if (response.files) {
      for (let responseFile of response.files) {
        let abnormalItemDialogFile = new DOAbnormalDialogItemFile();
        abnormalItemDialogFile.fileName = responseFile.fileName;
        abnormalItemDialogFile.fileExtension = responseFile.fileExtension;
        abnormalItemDialogFile.fileType = responseFile.fileType;
        abnormalItemDialogFile.fileDataUrl = `data:${responseFile.fileType};base64,${responseFile.fileContent}`;
        this.filePermission = responseFile.filePermission;
        this.fileOfAbnormalItemFileDialog.push(abnormalItemDialogFile);
      }
    }
  }

  private isFileSelectedInAbnormalItemFile(file: File): boolean {
    for (let abnormalItemFile of this.fileOfAbnormalItemFileDialog) {
      let fileName = file.name.split('.')
      if ((abnormalItemFile.fileName! + abnormalItemFile.fileType) === (fileName[0] + fileName[1] + file.type)) {
        return true;
      }
    }
    return false;
  }

  private convertToAbnormalItemFile(file: File, fileBase64: string) {
    let fileNameArray = file.name.split('.');
    let fileExtension: string | null = fileNameArray.pop()!;
    let fileName = fileNameArray.join('.')!;

    if (fileName.length == 0) {
      fileName = fileExtension;
      fileExtension = null;
    }

    let abnormalItemFile = new DOAbnormalDialogItemFile();
    abnormalItemFile.fileName = fileName;
    abnormalItemFile.fileExtension = fileExtension;
    abnormalItemFile.fileType = file.type;
    abnormalItemFile.fileDataUrl = `data:${file.type};base64,${fileBase64}`;
    return abnormalItemFile;
  }

  private onCloseAbnormalItemFileDialog() {
    this.getFileSubscribe?.unsubscribe();
    this.fileOfAbnormalItemFileDialog = [];
    this.backupFileOfAbnormalItemFileDialog = [];
    this.fileDocIdOfCurrentAbnormalItem = [];
    this.abnormalItemFileDialogMode = this.ABNORMAL_ITEM_FILE_DIALOG_MODE_ENUM.Edit;
    this.clearUserOperationOnAbnormalFileDialog();
  }

  private async convertFileToBase64(file: File): Promise<string | null> {
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let result = fileReader.result as string;
        if (result) {
          resolve(result.split(',')[1]);
        }
      }
      fileReader.onerror = () => reject(null)
    })
  }

  private saveDataChangesOnAbnormalFileDialog() {
    this.isAbnormalItemFileDialogLoading = true;

    let updateRequest: DOAbnormalDialogAbnormalItemFileUpdateRequest = this.createAbnormalItemFileUpdateRequest();
    this.doAbnormalService.updateAbnormalItemFile(updateRequest).subscribe({
      next: (response) => {
        if (response.newFileDocIds) {
          let newFileDocIds = response.newFileDocIds;
          for (let i = 0; i < newFileDocIds.length; i++) {
            this.fileDocIdOfCurrentAbnormalItem[i] = newFileDocIds[i];
          }
          this.updateDataDocIdOfAbnormalItemTable();
        }
        this.toastService.success(this.translateService.instant('DOAbnormal.Dialog.AbnormalItemFile.Toast.Success.SaveSuccess'));
      },
      error: (response) => {
        this.isAbnormalItemFileDialogLoading = false;
        this.toastService.error(this.translateService.instant('DOAbnormal.Dialog.AbnormalItemFile.Toast.Failure.SaveFailure') + response.status);
      },
      complete: () => {
        this.isAbnormalItemFileDialogLoading = false;
        this.clearUserOperationOnAbnormalFileDialog();
      }
    })
  }

  private createAbnormalItemFileUpdateRequest(): DOAbnormalDialogAbnormalItemFileUpdateRequest {
    let abnormalItemFileUpdateRequest: DOAbnormalDialogAbnormalItemFileUpdateRequest = new DOAbnormalDialogAbnormalItemFileUpdateRequest();
    abnormalItemFileUpdateRequest.userName = this.userService.userInfo.userName;
    abnormalItemFileUpdateRequest.operationDate = new Date();
    abnormalItemFileUpdateRequest.abnormalItemSeqNo = this.selectedRowOfAbnormalItemTable?.seqNo ?? -1;
    abnormalItemFileUpdateRequest.newFiles = this.newAbnormalItemFileBase64s;
    abnormalItemFileUpdateRequest.deletedAbnormalItemFileDocIds = this.deletedAbnormalItemFileDocIds;
    return abnormalItemFileUpdateRequest;
  }

  private updateDataDocIdOfAbnormalItemTable() {
    this.selectedRowOfAbnormalItemTable!.docIds = deepCopy(this.fileDocIdOfCurrentAbnormalItem) ?? [];
    const backupDataIndex = this.backupDataOfAbnormalItemTable.findIndex(data =>
      data.dataKey == this.selectedRowOfAbnormalItemTable?.dataKey);
    this.backupDataOfAbnormalItemTable[backupDataIndex].docIds = deepCopy(this.selectedRowOfAbnormalItemTable!.docIds) ?? [];
  }

  private clearUserOperationOnAbnormalFileDialog() {
    this.newAbnormalItemFileBase64s = [];
    this.deletedAbnormalItemFileDocIds = [];
  }

  private getTypeClass(fileType: string): string {
    return fileType.substring(0, fileType.indexOf('/'));
  }

  getCustomerOptions(event: any) {
    const conText: string = event.filter;
    if (!conText || conText.length < 3 || !this.queryFlag) return;
    const lower = conText.toLowerCase();
      this.queryFlag = false;
      this.notificationSubScriptionService.getCustomerOptionsByFilter(conText).subscribe({
        next: (options: any[]) => {
          let mapped = options.map<LaasOption>(x => ({
            label: x.customerName,
            value: x.customerCode,
          })).filter(c => String(c.value).toLowerCase().includes(lower));
          mapped.sort((a, b) => {
            const aVal = String(a.value).toLowerCase();
            const bVal = String(b.value).toLowerCase();
            const aStarts = aVal.startsWith(lower);
            const bStarts = bVal.startsWith(lower);
            if (aStarts && !bStarts) return -1;
            if (!aStarts && bStarts) return 1;
            if (aVal.length !== bVal.length) return aVal.length - bVal.length;
            return aVal.localeCompare(bVal);
          });
          this.consigneeKeyOptions = mapped;
          this.changeDetector.detectChanges();
          this.queryFlag = true;
        }
      });
  }

  onCustomerChange(values: string[]): void {
  this.searchFormGroup.controls.customers?.setValue(values);
  }

  //#endregion Abnormal Item File Dialog Function
}
